import _sectionClasses from './Page/Sections/index';
import _buttonClasses from './ButtonClasses';
import StandardGroupView from './Page/Groups/StandardGroupView';

const GroupViews = {
  'standard': StandardGroupView
};

_buttonClasses.push({
  classes: ['btn', 'fus-btn-secondary'],
  type: 'secondary',
  style: {color: '#FFF'},
  background: {
    color: '#225d50'
  }
})

export {_sectionClasses, _buttonClasses, GroupViews};
